
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {
  1: { // Exercise num
    unit: 'Unit 4',
    id: 'WB4-V2-U4-P29-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page37/E1/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page37/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page37/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page37/E1/3.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page37/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page37/E1/5.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page37/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page37/E1/7.jpg', input: 1, },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page37/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page37/E1/9.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page37/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page37/E1/11.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page37/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page37/E1/13.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page37/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page37/E1/15.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page37/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page37/E1/17.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page37/E1/18.jpg' },
        { url: 'img/FriendsPlus/Page37/E1/19.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page37/E1/20.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page37/E1/21.jpg' },
      ],
    ]
  },

  2: { // Exercise num
    unit: 'Unit 5',
    id: 'WB4-V2-U5-P37-E2',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page37/E2/Key/answerKey.png',
    component: D1,
    // recorder: true,
    // isAllowSubmit: false,
    maxLength: 2,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page37/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page37/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page37/E2/3.jpg', input: true, answer: "cl" },
        { url: 'img/FriendsPlus/Page37/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page37/E2/5.jpg', input: true, answer: "sl" },
        { url: 'img/FriendsPlus/Page37/E2/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page37/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page37/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page37/E2/9.jpg', input: true, answer: "cl" },
        { url: 'img/FriendsPlus/Page37/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page37/E2/11.jpg', input: true, answer: "sl" },
        { url: 'img/FriendsPlus/Page37/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page37/E2/13.jpg', input: true, answer: "gl" },
        { url: 'img/FriendsPlus/Page37/E2/14.jpg' },
      ],


    ],
  },
  3: { // Exercise num
    unit: 'Unit 5',
    id: 'WB4-V2-U5-P37-E3',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page37/E3/Key/answerKey.png',
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page37/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page37/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/3.jpg', input: true, answer: "gloves" },
        { url: 'img/FriendsPlus/Page37/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page37/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/6.jpg', input: true, answer: "slide" },
        { url: 'img/FriendsPlus/Page37/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page37/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/9.jpg', input: true, answer: "clock" },
        { url: 'img/FriendsPlus/Page37/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page37/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/12.jpg', input: true, answer: "clouds" },
        { url: 'img/FriendsPlus/Page37/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page37/E3/14.jpg' },
      ],
    ],
  },

}

export default json;